import { v4 as uuidv4 } from 'uuid';
import { GOOGLE_PLACES_TYPE } from '../../consts';
// todo MATAN: refactor this file

export const checkErrorMessage = (hasLength = ''):boolean => {
  return hasLength?.length !== 0;
};

type TalentObject = {
  talentId:string,
  latestVersion: string,
  firstName : string,
  lastName: string,
  phoneNumbers: string[],
  emails: string[],
  city: string,
  state: string,
  country: string,
  socialLinks:  SocialLinks[],
  attributes: KeyAttributes[],
  profileImage?: string,
  profileImageTempUrl?: string,
  technicalSkills: Skills[] | TechnicalSkill[],
  linkedinUrl: string,
  employmentHistory: EmploymentHistoryItem[],
  educationHistory: EducationHistoryItem[],
}

export const createTalentNewObject = (): TalentResponse => {
  return {
    talentId: uuidv4(),
    version: '',
    firstName: '',
    lastName: '',
    profileImageTempUrl: '',
    profileImage: '',
    phoneNumbers: [],
    emails: [],
    location: {
      city: '',
      state: '',
      country: '',
    },
    employmentHistory: [],
    educationHistory: [],
    attributes: [],
    socialLinks: [],
    webResults: [],
    technicalSkills: [],
    createdManually: false,
    createdBy: '',
    createdAt: '',
    updatedAt: '',
    updatedBy: '',
    linkedinUrl: '',
  };
};

export const createTalentObject = ({
  talentId,
  latestVersion,
  firstName,
  lastName,
  phoneNumbers,
  emails,
  city,
  state,
  country,
  socialLinks,
  profileImage,
  attributes,
  technicalSkills,
  linkedinUrl,
  employmentHistory,
  educationHistory,
  profileImageTempUrl,
}: TalentObject): TalentUpdate => {
  return {
    talentId,
    latestVersion,
    firstName,
    lastName,
    phoneNumbers,
    emails,
    location: {
      city,
      state,
      country,
    },
    profileImageTempUrl,
    profileImage,
    socialLinks,
    attributes,
    linkedinUrl,
    technicalSkills,
    employmentHistory,
    educationHistory,
    webResults: [],
  };
};

export const createEmptyTalentObject = (linkedinUrl: string): FormattedTalentResponse => (
  {
    talentId: '',
    version: '',
    firstName: '',
    lastName: '',
    profileImage: '',
    profileImageTempUrl: '',
    phoneNumbers: [],
    emails: [],
    location: {
      city: '',
      state: '',
      country: '',
    },
    employmentHistory: [],
    educationHistory: [],
    attributes: [],
    socialLinks: [],
    webResults: [],
    technicalSkills: [],
    createdManually: false,
    createdBy: '',
    createdAt: '',
    updatedAt: '',
    updatedBy: '',
    linkedinUrl,
  }
);

const findAddressValueByType = (locationType: string,
  googleAddress: google.maps.GeocoderAddressComponent[]):
google.maps.GeocoderAddressComponent | undefined => {
  return googleAddress.find((item: google.maps.GeocoderAddressComponent) => item.types
    .some((type: string) => type === locationType));
};

export const getPlaceBasedGoogle = (googleAddress: google.maps.GeocoderAddressComponent[],
  addressGeometry: google.maps.places.PlaceGeometry | undefined):{
  city: string | undefined,
  state: string | undefined,
  stateLong: string | undefined,
  country: string | undefined,
  countryLong: string | undefined,
  geometry?: {
    lat: number,
    lng: number,
  } | undefined
} => {
  const city = findAddressValueByType(GOOGLE_PLACES_TYPE.CITY, googleAddress)?.long_name;
  const googleState = findAddressValueByType(GOOGLE_PLACES_TYPE.STATE, googleAddress);
  const state = googleState?.short_name;
  const stateLong = googleState?.long_name;
  const googleCountry = findAddressValueByType(GOOGLE_PLACES_TYPE.COUNTRY, googleAddress);
  const country = googleCountry?.short_name;
  const countryLong = googleCountry?.long_name;
  let geometry;
  if (addressGeometry && addressGeometry.location) {
    geometry = {
      lat: addressGeometry.location.lat(),
      lng: addressGeometry.location.lng(),
    };
  }

  return {
    city,
    state,
    stateLong,
    country,
    countryLong,
    geometry,
  };
};

export const checkValidUrl = (str: string): boolean => {
  const url = /[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*)?/gi;
  const urlRegex = new RegExp(url);

  return  urlRegex.test(str);
};
